<template>
  <div id="app">
    <img src="./assets/logo.png" width=160 height=32>
    <div id="title">My Ethereum Wallet Address is</div>
    <div id="address_area">
      <center>
        <table style="border: 0px;">
          <tr>
            <td width=800>
              <div id="address_field">
                <input
                  type="text"
                  placeholder="0x"
                  maxlength="42"
                  v-model="walletAddress"
                  @keyup="walletValidator"
                />
              </div>
            </td>
            <td width=40 style="text-align: center;">
              <div v-if="validStatus === 1" id="correctIcon">
                <img src="./assets/correct-icon.png" width=24 height=24>
              </div>
              <div v-if="validStatus === 2" id="errorIcon">
                <img src="./assets/error-icon.png" width=24 height=24>
              </div>
            </td>
          </tr>
          <tr colspan="2">
            <td>
              <div id="message" v-if="validStatus === 2">{{errorMessage}}</div>
            </td>
          </tr>
        </table>
      </center>
    </div>
    <div id="dist-table">
      <transition name="fade">
        <template v-if="validStatus === 1">
          <div v-html="tableBody"></div>
        </template>
      </transition>
    </div>
    <div id="bottom_text">Please contact our admin for the further assistance.<br>
      If you have multiple contracts with same wallet address,
      the displayed amount will be inaccurate.<br><br>
      Telegram: @insureumadmin <br>
      Email: contact at zikto dot com<br>
    </div>
  </div>
</template>

<script>
/* global sha3:true */
/* global $:true */
/* global jQuery:true */

/**
 * Checks if the given string is a checksummed address
 *
 * @method isChecksumAddress
 * @param {String} address the given HEX adress
 * @return {Boolean}
*/
const isChecksumAddress = function isChecksumAddress(address) {
  const addressTrim = address.replace('0x', '');

  let i = 0;
  const addressHash = sha3(addressTrim.toLowerCase());

  for (i = 0; i < 40; i += 1) {
    // the nth letter should be uppercase if the nth digit of casemap is 1
    if ((parseInt(addressHash[i], 16) > 7 && addressTrim[i].toUpperCase() !== addressTrim[i])
      || (parseInt(addressHash[i], 16) <= 7 && addressTrim[i].toLowerCase() !== addressTrim[i])) {
      return false;
    }
  }
  return true;
};

/**
 * Checks if the given string is an address
 *
 * @method isAddress
 * @param {String} address the given HEX adress
 * @return {Boolean}
*/
const isAddress = function isAddress(address) {
  if (!/^(0x)?[0-9a-f]{40}$/i.test(address)) {
    // check if it has the basic requirements of an address
    return false;
  } else if (/^(0x)?[0-9a-f]{40}$/.test(address) || /^(0x)?[0-9A-F]{40}$/.test(address)) {
    // If it's all small caps or all all caps, return true
    return true;
  }

  // Otherwise check each case
  return isChecksumAddress(address);
};

/**
 * Add commas to number
 *
 * @method numberWithCommas
 * @param {String} number the given decimal number
 * @return {String} the number string with commas
 */
function numberWithCommas(num) {
  const regexp = /\B(?=(\d{3})+(?!\d))/g;

  return num.toString().replace(regexp, ',');
}

export default {
  name: 'App',
  components: {
  },
  props: {},
  data() {
    return {
      errorMessage: '',
      walletAddress: '',
      validStatus: 0,
      tableBody: '',
      statusIcon: '<img src="./assets/corrent-icon.png">',
    };
  },
  methods: {
    walletValidator() {
      const address = this.$data.walletAddress;
      const tokenRecord = {};
      let totalISR;
      let tableTags;
      const startDate = new Date(2018, 7, 6); // Month field is 0-based. Jan is 0, November is 11
      const distDate = new Date();

      if (!this.$data.walletAddress.length) {
        this.$data.errorMessage = '';
        this.$data.tableBody = '';
        this.$data.validStatus = 0;
        document.getElementById('address_field').style.borderBottomColor = '#ffffff';
        return;
      }

      if (!this.$data.walletAddress.startsWith('0x')) {
        this.$data.errorMessage = 'Ethereum address should be started with 0x';
        this.$data.tableBody = '';
        this.$data.validStatus = 2;
        document.getElementById('address_field').style.borderBottomColor = '#e82a2a';
        return;
      }

      if (!(isAddress(this.$data.walletAddress.toLowerCase()))) {
        this.$data.errorMessage = 'Not a valid Ethereum address';
        this.$data.tableBody = '';
        this.$data.validStatus = 2;
        document.getElementById('address_field').style.borderBottomColor = '#e82a2a';
        return;
      }

      $.ajax({
        url: 'https://124h2d9ftc.execute-api.ap-northeast-2.amazonaws.com/v2/execute',
        type: 'GET',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        data: `wallet_address=${address}`,
        async: false,
        success: (result, status) => {
          if (status === 'success') {
            const retRow = jQuery.parseJSON(result).length;

            if (retRow <= 0) {
              tableTags = '<p id="no_token">No token to distribute</p>';
            } else {
              $.each(jQuery.parseJSON(result), (index, value) => {
                tokenRecord.wallet_address = value.wallet_address;
                tokenRecord.name = value.name;
                tokenRecord.email = value.email;
                tokenRecord.phone = value.phone;
                tokenRecord.category = value.category;
                tokenRecord.M0 = value.M0;
                tokenRecord.M1 = value.M1;
                tokenRecord.M3 = value.M3;
                tokenRecord.M6 = value.M6;
                tokenRecord.M9 = value.M9;
                tokenRecord.Total = value.Total;

                totalISR = parseInt(value.M0, 10)
                           + parseInt(value.M1, 10)
                           + parseInt(value.M3, 10)
                           + parseInt(value.M6, 10)
                           + parseInt(value.M9, 10);
              });

              let tableHead = '';
              let tableRecordM0 = '';
              let tableRecordM1 = '';
              let tableRecordM3 = '';
              let tableRecordM6 = '';
              let tableRecordM9 = '';
              let tableFoot = '';
              let finalTokens = '';

              if (totalISR) {
                tableHead = '<center><table class="tokens"><thead><tr><th class="date_header">DATE</th><th class="amount_header">AMOUNT (ISR)</th></tr></thead>';

                if (parseInt(tokenRecord.M0, 10)) {
                  distDate.setFullYear(startDate.getFullYear());
                  distDate.setMonth(startDate.getMonth());
                  distDate.setDate(startDate.getDate());
                  finalTokens = tokenRecord.M0;

                  tableRecordM0 = `<tr class="content"><td class="date">${distDate.toDateString()}</td><td class="amount">${numberWithCommas(finalTokens)}</td>`;
                }
                if (parseInt(tokenRecord.M1, 10)) {
                  distDate.setFullYear(startDate.getFullYear());
                  distDate.setMonth(startDate.getMonth() + 1);
                  distDate.setDate(startDate.getDate());
                  finalTokens = tokenRecord.M1;

                  tableRecordM1 = `<tr class="content"><td class="date">${distDate.toDateString()}</td><td class="amount">${numberWithCommas(finalTokens)}</td>`;
                }
                if (parseInt(tokenRecord.M3, 10)) {
                  distDate.setFullYear(startDate.getFullYear());
                  distDate.setMonth(startDate.getMonth() + 3);
                  distDate.setDate(startDate.getDate());
                  finalTokens = tokenRecord.M3;

                  tableRecordM3 = `<tr class="content"><td class="date">${distDate.toDateString()}</td><td class="amount">${numberWithCommas(finalTokens)}</td>`;
                }
                if (parseInt(tokenRecord.M6, 10)) {
                  distDate.setFullYear(startDate.getFullYear());
                  distDate.setMonth(startDate.getMonth() + 6);
                  distDate.setDate(startDate.getDate());
                  finalTokens = tokenRecord.M6;

                  tableRecordM6 = `<tr class="content"><td class="date">${distDate.toDateString()}</td><td class="amount">${numberWithCommas(finalTokens)}</td>`;
                }
                if (parseInt(tokenRecord.M9, 10)) {
                  distDate.setFullYear(startDate.getFullYear());
                  distDate.setMonth(startDate.getMonth() + 9);
                  distDate.setDate(startDate.getDate());
                  finalTokens = tokenRecord.M9;

                  tableRecordM9 = `<tr class="content"><td class="date">${distDate.toDateString()}</td><td class="amount">${numberWithCommas(finalTokens)}</td>`;
                }

                tableFoot = '</table></center>';
                tableTags = `${tableHead}${tableRecordM0}${tableRecordM1}${tableRecordM3}${tableRecordM6}${tableRecordM9}${tableFoot}`;
              } else {
                tableTags = '<p id="no_token">No token to distribute</p>';
              }
            }
          } else {
            tableTags = `<p id="retry">Error: Somethnig happened in our end. Please retry in minute. [${status}]</p>`;
          }
        },
        error: (status, error) => {
          tableTags = `<p id="retry">Error: Somethnig happened in our end. Please retry in minute. [${status}:${error}]</p>`;
        },
      });

      this.$data.tableBody = tableTags;
      this.$data.errorMessage = '';
      this.$data.validStatus = 1;
      document.getElementById('address_field').style.borderBottomColor = '#d57c10';
    },
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Proza+Libre|Fira+Mono');

html, body {
  margin: 16px;
  background-color: #213367;
}

#app {
  justify-content: center;
  align-items: left;
  flex-direction: column;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #213367;
}

#dist-table {
  display: fex;
  margin-top: 36px;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-family: 'Proza Libre', sans-serif;
}

#title {
  font-family: 'Proza Libre', sans-serif;
  color: #ffffff;
  font-weight: 300;
  font-size: 36pt;
  margin-top: 162px;
}

#address_area {
  margin-top: 120px;
}

#address_field {
  border-bottom: 2px solid #ffffff;
}

#correctIcon {
  margin-left: 4px;
  margin-top: 8px;
}

#errorIcon {
  margin-left: 4px;
  margin-top: 8px;
}

#message {
  float: none;
  font-family: 'Proza Libre', sans-serif;
  color: #e82a2a;
  font-weight: 300;
  margin-top: 8px;
  font-size: 24px;
}

#bottom_text {
  margin-top:  80px;
  font-family: 'Proza Libre', sans-serif;
  color: gray;
  font-size: 14pt;
  color: #ececec;
  font-weight: 300;
}

input[type="text"]{
  width:800px;
  margin:0px;
  height:30px;
  background: transparent;
  color: #ffffff;
  border: 0;
  outline: 0;
  font-size: 30px;
  font-weight: 700;
  font-family: 'Proza Libre', sans-serif;
}

span {
  position: relative;
  color: white;
  display: inline-block;
  padding: 0.4rem 0;
  border-bottom: 4px solid #D5BA5E;
  outline: 0;
}

#retry {
  text-align: center;
  float: none;
  font-family: 'Proza Libre', sans-serif;
  color: #e82a2a;
  font-weight: 300;
  margin-top: 8px;
  font-size: 24px;
}

#no_token {
  text-align: center;
  float: none;
  font-family: 'Proza Libre', sans-serif;
  color: #ffffff;
  font-weight: 300;
  margin-top: 8px;
  font-size: 24px;
}

table.tokens {
  text-align: center;
  border: 0px;
  border-collapse: collapse;
}

th.date_header {
  color: #ffffff;
  background-color: #d28521;
  padding: 8px;
  font-size: 20px;
  font-weight: 600;
  border-left: 0px;
  border-top: 0px;
  border-bottom: 0px;
  border-right: 1px solid #213367;
  width: 360px;
}

th.amount_header {
  margin: 0px;
  color: #ffffff;
  background-color: #d28521;
  padding: 8px;
  font-size: 20px;
  font-weight: 600;
  border-left: 0px;
  border-top: 0px;
  border-bottom: 0px;
  border-left: 1px solid #213367;
  width: 360px;
}

tr.content {
  margin: 0px;
  color: #ffffff;
  padding: 8px;
  font-size: 28px;
  font-weight: 400;
}

td.date {
  margin: 0px;
  text-align: center;
  padding: 16px;
  width: 360px;
  border-left: 0px;
  border-top: 0px;
  border-right: 1px solid #d28521;
  border-bottom: 1px solid #d28521;
}

td.amount {
  margin: 0px;
  text-align: right;
  padding: 16px 56px 16px 0;
  width: 360px;
  border-right: 0px;
  border-top: 0px;
  border-left: 1px solid #d28521;
  border-bottom: 1px solid #d28521;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue